import CurrencyConfigListTable from './currencyConfigListTable.container';

export default CurrencyConfigListTable